import { ValidationCodes } from '../enums/ValidationCodes';

export const ValidationTypes = {
  NHSvalidation: {
    name: ValidationCodes.NHS,
    maxCodeLength: 10,
    errorLabels: ['nhsNumericError', 'nhsIncorrectLength'],
  },
};
